const width = document.documentElement.clientWidth
const size = 32
const fontSize = (width / 750) * size + 'px'
document.getElementsByTagName('html')[0].style.fontSize = fontSize
const el = document.createElement('style')
el.type = 'text/css'
el.innerText = `:root {--scale-size: ${32};}`
document.getElementsByTagName('head')[0].appendChild(el)

export default {}
